import * as THREE from "three";

let Colors = {
  white: 0xffffff,
  yellow: 0xffff00,
  orange: 0xffa500,
  lightBrown: 0xd2b48c,
  brown: 0xa0522d,
  darkBrown: 0x8b4513,
};

export default class Saturn {
  constructor() {
    this.mesh = new THREE.Object3D();

    // Geometry
    let geoSphere = new THREE.SphereGeometry(5, 32, 32);
    let geoTorus = new THREE.TorusGeometry(8, 0.5, 16, 100);
    let geoTorusInner = new THREE.TorusGeometry(7, 0.5, 16, 100);
    let geoTorusOuter = new THREE.TorusGeometry(9, 0.5, 16, 100);

    // Materials
    let matPlanet = new THREE.MeshPhongMaterial({
      color: Colors.lightBrown,
      flatShading: true,
    });
    let matRing1 = new THREE.MeshPhongMaterial({
      color: Colors.yellow,
      side: THREE.DoubleSide,
      flatShading: true,
    });
    let matRing2 = new THREE.MeshPhongMaterial({
      color: Colors.orange,
      side: THREE.DoubleSide,
      flatShading: true,
    });
    let matRing3 = new THREE.MeshPhongMaterial({
      color: Colors.white,
      side: THREE.DoubleSide,
      flatShading: true,
    });

    // Meshes
    let planet = new THREE.Mesh(geoSphere, matPlanet);
    planet.castShadow = true;
    planet.receiveShadow = true;

    let ring1 = new THREE.Mesh(geoTorus, matRing1);
    ring1.rotation.x = Math.PI / 2;
    ring1.castShadow = true;
    ring1.receiveShadow = true;

    let ring2 = new THREE.Mesh(geoTorusInner, matRing2);
    ring2.rotation.x = Math.PI / 2;
    ring2.castShadow = true;
    ring2.receiveShadow = true;

    let ring3 = new THREE.Mesh(geoTorusOuter, matRing3);
    ring3.rotation.x = Math.PI / 2;
    ring3.castShadow = true;
    ring3.receiveShadow = true;

    // Add to Object3D
    this.mesh.add(planet);
    this.mesh.add(ring1);
    this.mesh.add(ring2);
    this.mesh.add(ring3);
  }
}
